export const sizePerPageList = [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '50', value: 30 },
];

export const initialFilter = {
    filter: {
        // bank_pooling_uuid: "",
        amountlt: "",
        amountgt: "",
        channel_chargelt: "",
        channel_chargegt: "",
        diff_description: "",
        start_date: "",
        end_date: "",
        reconcile_hid: "",
        branch: "",
        bank: "",
        date: ""
    },
    pageNumber: 1,
    pageSize: 10
};

export const badge = (status) => {
    let data = {};
    switch (status) {
        case 'SETTLE':
            data = { text: 'SETTLE', type: 'success' };
            break;
        case 'DRAFT':
            data = { text: 'DRAFT', type: 'warning' };
            break;
        default:
            data = { text: status, type: 'info' };
    }


    return data;
};